// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"93":"934a8870","205":"ac7ecb2d","222":"1acb62d0","264":"5d31f738","341":"3303c8b1","461":"88888f83","466":"ca5174ee","541":"9f037b39","566":"4f20c993","670":"796fff5e","724":"6b9196df","753":"4a4f26c8","909":"a9b28d1a","942":"02e18ba2"}[chunkId] + ".js";
};